import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-styled-flexboxgrid';
import { useForm, Controller } from 'react-hook-form';
import { Button, TextLink } from '@vds/buttons';
import { ButtonIcon } from '@vds/button-icons';
import { Icon } from '@vds/icons';
import { Body, Micro } from '@vds/typography';
// import ReqInput from '../../../common/ReqInput/index';
import { Input } from '@vds/inputs';
import { Notification } from '@vds/notifications';
import { Tooltip } from '@vds/tooltips';
import { TitleLockup } from '@vds/type-lockups';
// eslint-disable-next-line import/no-named-as-default-member
import CheckBox from '../../../common/CheckBox/index';
import { selectStateCache } from '../@selectors';

// import EmailInputField from './EmailInput';
import { checkoutLabels } from '../Components/labels';
import { useCheckoutHooks } from '../@Redux/checkout.hooks';
import * as actionTypes from '../@Redux/actionTypes';
import * as validation from '../../../common/validation';
import { selectManualContactInfo, selectContactInfoEditResponse } from '../../@Redux/selectors/checkout.selectors';
import { useDbounceValueHook } from '../../../common/hooks/useDbounceHook';
import { renderHTML, isMVA, isMobile } from '../../../common/Helpers';
import { getContactNumber } from '../../../common/ContactInfoUtils';
// import { unParseNumber } from '../../../common/ContactInfoUtils';

const ContactInfoEdit = (props) => {
  const stateCache = useSelector((state) => selectStateCache(state), shallowEqual);
  const { primaryUserInfo = {}, isHomePhoneAvailable, cartCreatorInfo, SetUp, accountNumber } = useCheckoutHooks(stateCache);
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [emailValue, setEmailValue] = useState('');
  const [phoneNumber] = useState('');
  const isManual = useSelector((state) => selectManualContactInfo(state), shallowEqual);
  const isContactInfoEdited = useSelector((state) => selectContactInfoEditResponse(state), shallowEqual);
  const dbouncedEmailValue = useDbounceValueHook(emailValue);
  const dbouncedMobileValue = useDbounceValueHook(phoneNumber);
  const contactInfo = {};
  const isMobileDevice = isMobile() || isMVA() || window.innerWidth < 768;
  const notificationText = checkoutLabels.notificationText.replace('<email address>', emailValue);
  const cqContent = {
    title: props.title,
    subTitle: props.subTitle,
  };

  useEffect(() => {
    validateEmail(dbouncedEmailValue);
  }, [dbouncedEmailValue]);

  useEffect(() => {
    validateMobile(dbouncedMobileValue);
  }, [dbouncedMobileValue]);

  useEffect(() => {
    if (isContactInfoEdited === 'success') {
      hideContactinfoEditForm();
    }
  }, [isContactInfoEdited]);

  useEffect(() => {
    if (isManual === 'Invalid' || isManual === 'manual' || isManual === 'false' || isManual === 'maxAttempts') {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
  }, [isManual]);

  const {
    control,
    setFocus,
    formState: { errors },
    // getValues,

    setValue,
    handleSubmit,
    getFieldState,
    // register,
  } = useForm({
    mode: 'onChange',
    // reValidateMode: 'onChange' || 'onBlur',
    submitFocusError: true,
    // shouldUnregister: false,
    // values,
    // keepDefaultValues: true ,
  });
  const erroArray1 = Object.keys(errors);
  useEffect(() => {
    const erroArray = Object.keys(errors);
    dispatch({ type: 'CONTACT_INFO_ERRORS', data: erroArray });
    if (!erroArray?.length) return;
    const firstError = erroArray[0];
    if (firstError) {
      setFocus(firstError);
      if (firstError) {
        setFocus(firstError);
        const firstErrorElement = document.getElementsByName(firstError);
        if (firstErrorElement && firstErrorElement[0]) {
          firstErrorElement[0].focus();
        }
      }
    }
  }, [erroArray1.length, setFocus]);

  const verifyEmail = () => {
    dispatch({ type: actionTypes.VERIFY_EMAIL_API, email: emailValue });
  };
  // console.log
  const validateEmail = (email) => {
    if (email.length > 0) {
      if (validation.isValidEmail(email)) {
        setEmailError(false);
        dispatch({ type: actionTypes.VALIDATE_EMAIL, email });
      }
      if (!validation.isValidEmail(email)) {
        setEmailError(true);
      }
    }
  };
  const validateMobile = (mobileNo) => {
    if (validation.isValidNANPPhoneNumber(mobileNo)) {
      dispatch({ type: actionTypes.VALIDATE_MOBILE, mobileNo });
    }
  };
  // console.log('emailErrorvalue', emailError);
  const confirmVerifyButtons = [
    {
      children: 'Confirm',
      size: 'small',
      ariaLabel: 'email-confirm-button',
      role: 'button',
      use: 'secondary',
      width: '100px',
      id: 'handle-verify',
      'data-testid': 'confirm-email-submit',
      onClick: (e) => {
        validateEmail(emailValue);
        e.preventDefault();
      },
    },
  ];

  const hideContactinfoEditForm = (resetEmailError) => {
    props.showContactinfoEditForm(true);
    if (resetEmailError) {
      // alert('HELLO');
      setEmailError(false);
    }
  };

  const handleCheckbox = () => {
    setChecked(!checked);
    // setChecked(e?.target.checked);
  };

  const submitContactInfo = (values) => {
    // console.log('emailError', emailError);

    if (emailError) {
      return null;
    }
    let data = {};
    let param = {};
    let cartDetails = {};
    const creditCheckRequest = null;
    const installType = SetUp === 'Self Setup' ? 'Self' : 'Prof';
    const homePhoneAdded = isHomePhoneAvailable;
    const { firstName, lastName, email, contactNumber } = values;
    param = [
      {
        firstName,
        lastName,
        email,
        phoneNumber: contactNumber.replaceAll('-', ''),
        mtn: homePhoneAdded ? 'newLine2' : 'newLine1',
        receiveSpecialOfferUpdates: checked,
      },
    ];
    cartDetails = {
      cartCreator: cartCreatorInfo,
      accountNumber,
    };
    data = {
      param,
      cartDetails,
    };
    dispatch({ type: 'POST_DATA', data, homePhoneAdded, creditCheckRequest, installType });
    // dispatch({ type: 'ISPU_CONTACTINFO_UPDATE_EXPRESSCHECKOUT', data, homePhoneAdded });
  };
  // const { onChange } = register('phoneNumber');

  return (
    <>
      <Row style={{ display: 'flex', justifyContent: 'space-between', padding: '0px' }}>
        <Col style={{ margin: '0' }}>
          <Body size="large" primitive="p" bold>
            {checkoutLabels?.CustomerInformation}
          </Body>
        </Col>
        <div style={{ margin: '0' }}>
          <Col>
            <ButtonIcon
              kind="ghost"
              size="small"
              surface="light"
              surfaceType="colorFill"
              onClick={(e) => {
                hideContactinfoEditForm(true);
                if (e) {
                  e.preventDefault();
                }
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  hideContactinfoEditForm(true);
                  if (e) {
                    e.preventDefault();
                  }
                }
              }}
              renderIcon={(propsForIcon) => <Icon name="close" {...propsForIcon} />}
            />
          </Col>
        </div>
      </Row>

      <form form="contactInfoEditForm">
        <Row>
          <Col top="12px" xs={12} lg={12} sm={12}>
            <TitleLockup
              data={{
                title: {
                  primitive: 'p',
                  bold: false,
                  size: isMobileDevice ? 'titleLarge' : 'titleXLarge',
                  children: cqContent?.title,
                },
                subtitle: {
                  size: 'bodyLarge',
                  children: cqContent?.subTitle,
                },
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6} md={6} sm={6} aria-live="assertive">
            <Controller
              name="firstName"
              defaultValue={primaryUserInfo?.firstName || contactInfo?.firstName}
              control={control}
              rules={{
                required: true,
                validate: (val) => validation.isValidNameWithSpace(val.trim()),
              }}
              render={({ field }) => (
                <Input
                  inputId="contactinfo_firstname"
                  type="text"
                  label="First name"
                  maxLength="40"
                  data-cs-mask
                  containsPii
                  error={false || !field.value || errors.firstName?.type === 'required' || errors.firstName?.type === 'validate'}
                  errorText={checkoutLabels.firstNameRequiredError}
                  success={getFieldState('firstName').invalid === false}
                  {...field}
                />
              )}
            />
          </Col>
          <Col xs={12} lg={6} md={6} sm={6} aria-live="assertive">
            <Controller
              name="lastName"
              defaultValue={primaryUserInfo?.lastName || contactInfo?.lastName}
              control={control}
              rules={{
                required: true,
                validate: (val) => validation.isValidNameWithSpace(val.trim()),
              }}
              render={({ field }) => (
                <Input
                  type="text"
                  inputId="contactinfo_lastname"
                  label="Last name"
                  maxLength="40"
                  data-cs-mask
                  containsPii
                  error={false || !field.value || errors.lastName?.type === 'required' || errors.lastName?.type === 'validate'}
                  errorText={checkoutLabels.lastNameRequiredError}
                  success={getFieldState('lastName').invalid === false}
                  {...field}
                />
              )}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: '12px' }}>
          <Col xs={12} lg={6} md={6} sm={6} aria-live="assertive">
            <Controller
              name="email"
              control={control}
              defaultValue={primaryUserInfo?.emailId || contactInfo?.email}
              rules={{
                required: true,
                // validate: (val) => validation.isValidEmail(val),
              }}
              render={({ field }) => (
                <Input
                  type="text"
                  inputId="contactinfo_email"
                  label="Email address"
                  data-cs-mask
                  containsPii
                  required
                  maxLength="100"
                  success={getFieldState('email').invalid === false}
                  error={
                    false ||
                    errors.email?.type === 'required' ||
                    // errors.email?.type === 'validate' ||
                    (emailValue?.length > 0 ? !validation.isValidEmail(emailValue) : field?.value === undefined) ||
                    isManual === 'manual' ||
                    isManual === 'false' ||
                    isManual === 'maxAttempts'
                  }
                  errorText={isManual === 'manual' || isManual === 'maxAttempts' ? ' ' : ' Please enter a valid email address'}
                  {...field}
                  onChange={(e) => {
                    const email = e.target.value ? e.target.value : '';
                    setValue('email', email);
                    setEmailValue(email);
                  }}
                  helperText={checkoutLabels.contact_info_email_helper_text}
                  helperTextPlacement="bottom"
                />
              )}
            />
          </Col>
          <Col xs={12} lg={6} md={6} sm={6} aria-live="assertive">
            <Controller
              name="contactNumber"
              control={control}
              rules={{
                required: true,
                validate: (val) => validation.isValidNANPPhoneNumber(val?.replaceAll('-', '')),
              }}
              defaultValue={getContactNumber(primaryUserInfo)}
              render={({ field }) => (
                <Input
                  type="tel"
                  label={checkoutLabels.contact_info_mobile_label}
                  data-cs-mask
                  success={getFieldState('contactNumber').invalid === false}
                  inputId="personalinfo_contactNumber"
                  aria-required="true"
                  minLength={10}
                  maxLength={10}
                  required
                  error={
                    !field.value ||
                    false ||
                    errors.contactNumber?.type === 'required' ||
                    errors.contactNumber?.type === 'validate' ||
                    (phoneNumber?.length > 0 ? !validation.isValidNANPPhoneNumber(phoneNumber) : false)
                  }
                  errorText="Please enter a valid 10 digit phone number"
                  {...field}
                  onChange={(e) => {
                    let contactNumber = e.target.value ? e.target.value : '';
                    if (contactNumber) {
                      contactNumber = validation.normalizePhoneNumberRedesign(e.target.value);
                      e.target.value = validation.normalizePhoneNumberRedesign(contactNumber.trim());
                    }
                    setValue('contactNumber', e.target.value);
                  }}
                  helperText="Your mobile number will be used to provide service updates."
                  helperTextPlacement="bottom"
                />
              )}
            />
          </Col>
        </Row>
        <Row>
          <Col top="12px" xs={12} lg={12} sm={12}>
            <div>
              {isManual === 'maxAttempts' && (
                <Body size="small" primitive="h6">
                  {checkoutLabels.maxtAttemptsText}
                </Body>
              )}
              {isManual === 'manual' && (
                <div>
                  <Micro primitive="span">{renderHTML('Please ')}</Micro>
                  <Micro primitive="span">
                    <TextLink
                      id="textLink"
                      data-testid="click-here"
                      aria-label="click-here"
                      onClick={verifyEmail}
                      role="link"
                      ariaLabel="manual-email-verify-link"
                      onKeyDown={(e) => {
                        if (e.keyCode === 13 || e.keyCode === 32) {
                          verifyEmail();
                          e.preventDefault();
                        }
                      }}
                    >
                      click here
                    </TextLink>
                  </Micro>
                  <Micro primitive="span">{renderHTML(' to validate your email address or enter a different one ')}</Micro>
                  <Tooltip
                    id="emailValTooltip"
                    containerId="email-tooltip"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    direction="bottom"
                    role="tooltip"
                    size="small"
                    ariaLabel="Verify email information tooltip"
                  >
                    <span>{checkoutLabels.tooltTipText}</span>
                  </Tooltip>
                  <div className="displayInlineFlex" />
                </div>
              )}
              {isManual === 'verify' && (
                <Notification
                  type="info"
                  title="Please check your email."
                  subtitle={renderHTML(notificationText)}
                  hideCloseButton
                  className="marginTop15"
                  layout="vertical"
                  buttonData={confirmVerifyButtons}
                />
              )}
            </div>
          </Col>
        </Row>
      </form>

      <Row style={{ marginTop: '20px' }}>
        <Col xs={12} lg={12}>
          <CheckBox
            className="checkBoxContactInfo"
            id="checkBoxContactInfo"
            name="checkBoxContactInfo"
            // label="Yes, I'd like to receive special offers and updates by calls or automated texts to the mobile number provided. Consent is not a condition to purchase products or services. Standard messaging rates may apply."
            component="input"
            type="checkbox"
            analyticstrack="5G-sendSpecialOffersCheck"
            ariaLabel="5G-sendSpecialOffersCheck"
            dataTrack={'{"type": "link",  "name": "5G-sendSpecialOffersCheck"}'.replace('$checkedState', checked ? 'checked' : 'Unchecked')}
            selected={checked}
            onChange={() => handleCheckbox()}
            onKeyPress={(e) => {
              e.preventDefault();
              if (e.key === 'Enter') {
                setChecked(!checked);
              }
            }}
            tabIndex="0"
          >
            {checkoutLabels.checkBoxText}
          </CheckBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button type="submit" onClick={handleSubmit(submitContactInfo)} use="secondary" style={{ marginTop: '20px' }}>
            Update
          </Button>
        </Col>
      </Row>
    </>
  );
};

ContactInfoEdit.propTypes = {
  showContactinfoEditForm: PropTypes.func,
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

export default ContactInfoEdit;
